<section class="px-3 py-4">
  <header class="flex items-center justify-between">
    <button
      tuiIconButton
      type="button"
      class="me-4"
      appearance="transparent"
      size="s"
      (click)="goBack()"
    >
      <tui-icon
        [style.border-width.rem]="0.25"
        icon="@tui.arrow-left"
        class="x-text-01 text-2xl!"
      ></tui-icon>
    </button>
    <h1 class="font-medium x-text-01 typo-h6 flex">
      {{ 'group_actions.selected.selected_requests' | translate }}
      <span tuiBadge appearance="primary" size="l" class="ms-2">{{
        $selectedRequestsCount()
      }}</span>
    </h1>
    <button
      appearance="icon"
      iconStart="@tui.x"
      tuiIconButton
      type="button"
      size="m"
      (click)="$viewObserver().complete()"
    ></button>
  </header>
  <section>
    <table tuiTable size="s" class="white-no-borders-table">
      <thead>
        <tr>
          <th tuiTh class="text-left typo-body-l">
            {{ 'group_actions.selected.request' | translate }}
          </th>
          <th tuiTh>{{ 'group_actions.selected.contract' | translate }}</th>
          <th tuiTh>{{ 'group_actions.selected.project' | translate }}</th>
          <th tuiTh></th>
        </tr>
      </thead>
      <tbody tuiTbody>
        @for (
          selectedRequest of $selectedRequests();
          track selectedRequest.id
        ) {
          <tr>
            <td tuiTd>{{ selectedRequest.requestNumber }}</td>
            <td tuiTd>{{ selectedRequest.contract }}</td>
            <td tuiTd>{{ selectedRequest.projectNumber }}</td>
            <td tuiTd>
              <button
                tuiIconButton
                type="button"
                appearance="transparent"
                size="s"
                (click)="removeRequest(selectedRequest)"
              >
                <tui-icon
                  [style.border-width.rem]="0.25"
                  class="x-text-danger text-2xl!"
                  icon="@tui.x"
                ></tui-icon>
              </button>
            </td>
          </tr>
        }
      </tbody>
    </table>
  </section>
</section>
